<template>
  <div>
      <h1>Tags</h1>
        <div class="widget-buttons flex">
          <div class="input-box" style="height:33px;margin-right:10px;width:220px;">
            <input v-model="newTag" type="text" placeholder="Enter Tag...">
          </div>
          <button v-on:click="createTag(newTag)" style="height:33px;width:120px;">Create Tag</button>
        </div>
        <table style="width:500px;">
          <tr>
            <th>Tag</th>
            <th>Count</th>
            <th></th>
          </tr>
          <tr v-for="(tag,key) in tags" :key="key">
            <td>{{tag.name}}</td>
            <td>{{tag.count}}</td>
            <td><button v-on:click="removeTag(tag.name)">Remove</button></td>
          </tr>
        </table>
  </div>
</template>

<script>
import Vue from "vue";
import firebase from "firebase";
import VueFirestore from "vue-firestore";
require("firebase/firestore");
Vue.use(VueFirestore);
var firestore;

export default {
  data: function() {
    firestore = firebase.firestore();
    return {
      newTag: ""
    };
  },
  firestore() {
    return {
      // Collection
      tags: firestore.collection("tags")
    };
  },
  methods: {
    createTag(tag) {
      // Replace spaces with dashes, everything must be a lower case letter
      tag = tag.toLowerCase().replace(/\s/g, '-').replace(/[^a-z0-9\-]+/gi, '');
      var fail = false;
      this.tags.forEach((eachTag) => {
        if(tag == eachTag.name) {
          alert("This tag already exists.");
          fail = true;
        }
      });
      if(fail) return;
      firestore.collection("tags").doc(tag).set({
        name: tag,
        count: 0
      });
    },
    removeTag(tag) {
      var result = confirm("This will delete this tag and remove its usage from all articles where it is used. ARE YOU SURE??");
      if(result) {
        firestore.collection("tags").doc(tag).delete();
      }
    }
  },
  mounted() {

  }
};
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// tags.vue?19ca1822